<template lang="html">
 <section class="widgets">
  <div class="row">

    <div class="col-md-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <div id="map"></div>
            <input name="lat" type="text" v-model="lat" class="form-control" readonly="yes" required=""><br>
            <input name="lng" type="text" v-model="lng" ref="myLngField" class="form-control" readonly="yes" required="">
        </div>
     </div>
    </div>
  </div>
  </section>
 </template>
<script lang="js">
var map;
var marker = false;
import axios from 'axios'
export default {
  name: 'news',
  data () {
    return {
      loading:'',
      lat: '',
      lng: '',
    }
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    getList () {
        var vm=this;
            //The center location of our map.
    var centerOfMap = new google.maps.LatLng(10.030551, 76.524354);

    //Map options.
    var options = { 
 zoom: 12, 
 center: centerOfMap, // Centered 
 mapTypeId: google.maps.MapTypeId.ROADMAP, 
 mapTypeControl: false 
 }; 
     var map = new google.maps.Map(document.getElementById('map'), options); 
    google.maps.event.addListener(map, 'click', function(event) {                
        var clickedLocation = event.latLng;
        if(marker === false){
            marker = new google.maps.Marker({
                position: clickedLocation,
                map: map,
                draggable: true //make it draggable
            });
            google.maps.event.addListener(marker, 'dragend', function(event){
                vm.markerLocation();
            });
        } else{
            marker.setPosition(clickedLocation);
        }
        //Get the marker's location.
        vm.markerLocation();
    });

    },
    markerLocation(){
         var currentLocation = marker.getPosition();
      this.lat = currentLocation.lat(); //latitude
    this.lng = currentLocation.lng(); //longitude
    }
  }
}
</script>
<style>
.nameOfTheClass {
  max-width: 250px;
}
#map {
  width: 500px;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/mapcheck.vue